<template>
<div class="mediumheader-icons">
    <div class="header-text">
        <span>{{widgetConfig.HeaderText}}</span>
    </div>
    <div class="divider-line"></div>
    <div class="mediumheadericons-body">
        <div class="icon-div m-l-0">
            <div class="icon-container"> <img class="icon-style" :src="widgetConfig.IconUrl1" alt=""></div>
            <div class="body-container" v-if="widgetConfig.BodyText1">
                <p class="body-text" v-html="widgetConfig.BodyText1"></p>
            </div>
        </div>
        <div class="icon-div">
            <div class="icon-container"> <img class="icon-style" :src="widgetConfig.IconUrl2" alt=""></div>
            <div class="body-container" v-if="widgetConfig.BodyText2">
                <p class="body-text" v-html="widgetConfig.BodyText2"></p>
            </div>
        </div>
        <div class="icon-div m-r-0">
            <div class="icon-container"> <img class="icon-style" :src="widgetConfig.IconUrl3" alt=""></div>
            <div class="body-container" v-if="widgetConfig.BodyText3">
                <p class="body-text" v-html="widgetConfig.BodyText3"></p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "ArticleMediumHeaderIcons",
    props: {
        widgetConfig: Object
    },
}
</script>

<style lang="scss" scoped>
.mediumheader-icons {

    margin: 24px auto;
    padding: 0px 15px;

    .header-text {
        font-family: $font-family-primary;
        font-style: normal;
        font-weight: 300;
        font-size: 26px;
        line-height: 36px;
        text-align: center;
        color: #000000;
    }

    .divider-line {
        border-bottom: 5px solid $red-primary;
        margin: 16px auto;
        width: 120px;
    }

    .mediumheadericons-body {
        display: flex;
        padding-top: 16px;

        .m-r-0 {
            margin-right: 0px !important;
        }

        .m-l-0 {
            margin-left: 0px !important;
        }

        .icon-div {
            width: 314px;
            display: flex;
            flex-direction: column;
            margin: 0px 12px;

            .icon-container {

                margin: 0 auto;

                .icon-style {
                    width: 132px;
                    height: 132px;
                    background: #C4C4C4;
                }
            }

            .body-container {
                text-align: center;
                margin-top: 16px;

                .body-text {
                    width: 314px;
                    height: auto;
                    line-height: 26px;
                    margin: 0 auto;
                }
            }
        }
    }
}

@include wide-mobile {

    .mediumheader-icons {
        margin: 24px;
        padding: 0px;

        .header-text {
            width: 100%;
            text-align: center;
        }

        .divider-line {
            border-bottom: 5px solid $red-primary;
            margin: 16px auto;
            width: 120px;
        }

        .mediumheadericons-body {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .icon-div {
            margin: 12px 0px !important;
            width: 100% !important;

            .body-container {
                .body-text {
                    width: 100% !important;
                }
            }
        }

    }
}

@include tablet-max {
    .mediumheader-icons {
        .mediumheadericons-body {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .icon-div {
                margin: 12px 0px;
                width: 100%;

                .body-container {
                    .body-text {
                        width: 100%;
                    }
                }
            }
        }
    }
}
</style>
